<template>
    <v-pagination
        outlined
        total-visible="7"
        v-model="getLogFiltros.current_page"
        :length="getLogs.last_page"
        @input="setPage($event)"
    ></v-pagination>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'getLogs',
            'getLogFiltros'
        ])
    },
    methods: {
        ...mapActions([
            'listarLogs'
        ]),
        setPage(page) {
            this.getLogFiltros.current_page = page
            this.getLogFiltros.page = page
            this.listarLogs()
        }
    }
}
</script>